// @ts-nocheck
import HeaderState from "@store/Framework/Store/Bunzl/Components/Header/HeaderState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import constants from "@store/constants";
import {
    HeaderHeightParameter,
    HeaderIsFixedParameter,
    HeaderIsFullOpacityParameter,
} from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";
import { Draft } from "immer";

const initialState: HeaderState = {
    isFixed: false,
    isFullOpacity: false,
    headerHeight: {
        mainHeight: constants.defaultHeaderHeight.mainHeight,
        secondaryHeight: constants.defaultHeaderHeight.secondaryHeight,
    },
};

const actions = {
    "Store/Components/Header/SetIsFixed": (
        draft: Draft<HeaderState>,
        action: { parameter: HeaderIsFixedParameter },
    ) => {
        draft.isFixed = action.parameter;
    },
    "Store/Components/Header/SetFullOpacity": (
        draft: Draft<HeaderState>,
        action: { parameter: HeaderIsFullOpacityParameter },
    ) => {
        draft.isFullOpacity = action.parameter;
    },
    "Store/Components/Header/SetHeaderHeight": (
        draft: Draft<HeaderState>,
        action: { parameter: HeaderHeightParameter },
    ) => {
        draft.headerHeight = action.parameter;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlComponentsHeaderActions = Parameters<typeof reducer>[1];
export default reducer;
